
import { ADD_PLAN, ADD_PLAN_FAILED, ADD_PLAN_SUCCESSFUL, API_ERROR, RESET_PAY_INFO, RESET_RESPONSE_MESSAGE } from "./actionTypes"
const initialState = {
  plan: null,
  repMessage: null,
  planAddLoading: false,
  apiError: false,
  payInfo: null,
  planAdded: false,
}

const Plan = (state = initialState, action) => {
  const { responseCode, responseMessage, response, responseStatus, showMessage, planId } = action.payload || {};
  switch (action.type) {
    case ADD_PLAN:
      state = {
        ...state,
        planAddLoading: true,
      }
      break
    case ADD_PLAN_SUCCESSFUL:
      state = {
        ...state,
        planAddLoading: false,
        repMessage: responseMessage,
        payInfo: response.inv_pay,
        plan: response,
        planAdded: true,
        externalPlanId: action.payload?.plan_id,
      }
    case ADD_PLAN_FAILED:
      state = {
        ...state,
        planAddLoading: false,
        repMessage: responseMessage,
      }
      break
    case RESET_PAY_INFO:
      state = {
        ...state,
        payInfo: null
      }
      break
    case API_ERROR:
      state = {
        ...state,
        apiError: true,
        planAddLoading: false,
      }
      break
    case RESET_RESPONSE_MESSAGE:
      state = {
        ...state,
        repMessage: null,
        planAdded: false,
      }
      break

    default:
      state = { ...state }
      break
  }
  return state
}

export default Plan
